// bulk affidavit drop-down menu options below
export const SPECIFIC_PUBLICATION_DATE = 'Specific publication date';
export const ALL_INCOMPLETE_AFFIDAVITS = 'All incomplete affidavits';
export const AFFIDAVITS_AWAITING_PUBLICATION =
  'Affidavits awaiting publication';
